import {TranslationObject} from '@colonist/i18n'
import {UIMNotificationView} from './UIMNotificationView'
import {UITopNotificationRateResponseValue, UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController'
import {createButtonIn, createDivIn, createExternalImgIn} from '../../../shared/scripts/ui_utils/DomUtils'
import IconThumbsDown from '@static/images/icon_thumbsdown.svg'
import IconThumbsUp from '@static/images/icon_thumbsup.svg'
import {ImageURL} from '@colonist/types'

export class UIMNotificationViewRate extends UIMNotificationView {
    constructor(text: TranslationObject, onResponse: (value: UITopNotificationRateResponseValue) => void) {
        const showCloseButton = false
        super(text, UITopNotificationType.Information, undefined, undefined, undefined, undefined, showCloseButton)

        const onClickRateButton = (value: UITopNotificationRateResponseValue) => {
            this.close()
            onResponse(value)
        }

        const container = createDivIn(this.notification, 'notificationRateButtonsContainer')
        UIMNotificationViewRate.createRateButton(container, 'red', IconThumbsDown, {key: 'strings:imgAlts.IconThumbDown'}, () => onClickRateButton('negative'))
        UIMNotificationViewRate.createRateButton(container, 'green', IconThumbsUp, {key: 'strings:imgAlts.IconThumbUp'}, () => onClickRateButton('positive'))

        document.addEventListener('click', () => {
            this.close()
        }, {once: true})
    }

    private static createRateButton(container: HTMLElement, className: string, image: ImageURL, imgAlt: TranslationObject, onClick: () => void): void {
        const button = createButtonIn(container, 'notificationRateButton ' + className, {key: 'strings:colonistCommon.utils.emptyString'})
        button.onclick = onClick
        createExternalImgIn(button, image, imgAlt)
    }
}
